export default __webpack_public_path__ + "static/media/push-floor.b09e4be7.png";